<template>
  <div class="content r-c">
    <div class="c282">
      <h3>PREGLEJTE ŽE NAREJENE IZRAČUNE</h3>
      <ul>
        <li class="l1">
          <a href>
            <span class="title">TIPIČNA SITUACIJA 1</span>
            <span>Mlada družina z otrokom, ki živi v stanovanju.</span>
          </a>
        </li>
        <li class="l2">
          <a href>
            <span class="title">TIPIČNA SITUACIJA 2</span>
            <span>4 članska družina, ki živi v hiši.</span>
          </a>
        </li>
        <li class="l3">
          <a href>
            <span class="title">TIPIČNA SITUACIJA 3</span>
            <span>4 članska družina, ki živi v stanovanju.</span>
          </a>
        </li>
        <li class="l4">
          <a href>
            <span class="title">TIPIČNA SITUACIJA 4</span>
            <span>2 starejši osebi, ki živita v stanovanju.</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="infopush ip-n">
      <a href="http://www.uresnicujmo.si/nasveti" target="_blank" title="Nasveti">
        <span class="title">Nasveti</span>
        <span>Preverite dodatne nasvete in prihranite več!</span>
      </a>
    </div>
    <div class="infopush ip-help">
      <a
        href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev"
        target="_blank"
        title="O Aplikaciji"
      >
        <span class="title">O Aplikaciji</span>
        <span>Vas zanima, na kakšni osnovi izračunamo vaše prihranke?</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Situations',
  components: {},
  props: {},
};
</script>

<style>
</style>